<div class="project-display-container">
    <eic-project-actions [project]="currentProject"></eic-project-actions>
    <button mat-raised-button *ngIf="currentProject.discriminator==='Asset'" class="feedback-button left-gap"
        (click)="locateOnMap(projectLocations.locatorPosition)">
        Locate on Map
    </button>
    <div *ngIf="noLocation" class="no-location">
        The location of this {{currentProject.discriminator}} could not be found
    </div>

    <eic-project-header [projectHeader$]="projectHeader$" [discriminator]="currentProject.discriminator"
        [lifecycle]="currentProject.lifecycle">
    </eic-project-header>

    <eic-project-fid *ngIf="projectFid$ | async as projectFid" [fid]="projectFid"></eic-project-fid>

    <eic-project-related-projects-and-links [relatedProjects$]="relatedProjects$"
        [links$]="projectLinks$"></eic-project-related-projects-and-links>

    <eic-asset-related-projects [assetRelatedProjects$]="assetRelatedProjects$"></eic-asset-related-projects>

    <eic-equipment-and-capacities-container [optionalComponents$]="optionalComponents$" [projectId]="projectId"
        [discriminator]="currentProject.discriminator" [project$]="project$">
    </eic-equipment-and-capacities-container>

    <eic-project-locations #projectLocations [projectLocations]="projectLocations$ | async"></eic-project-locations>

    <eic-operating-companies [operatingCompanies$]="operatingCompanies$"></eic-operating-companies>
    <eic-asset-operators [assetOperators$]="assetOperators$"></eic-asset-operators>

    <eic-contract-stages-container [projectContractStages$]="projectContractStages$" [currentProject]="currentProject">
    </eic-contract-stages-container>
    <eic-asset-contractors [assetContractors$]="assetContractors$"></eic-asset-contractors>

    <eic-project-notes-container [projectId]="projectId"
        [discriminator]="currentProject.discriminator"></eic-project-notes-container>

    <!--
        The logEvent Directives needs to be fed the discriminator 
        so that it will make the correct API call
    -->
    <div logEvent [initialDelay]="5" mode="single" [data]="logData" [discriminator]="currentProject.discriminator"
        operation="access">
    </div>
</div>